export default __webpack_public_path__ + "static/img-channel-thumbnail-second-22fbdf0d4d5af89b3364e607e31a110b.png";